// extracted by mini-css-extract-plugin
module.exports = {"labelError":"_1ZKj8QpYzXsvNrnWUMNBgm"};